import Device from '../Device';

const questions = [
  {
    type: 'modal',
    name: 'modal',
    label: 'step3TeslaExternalEnrollLabel',
    model: 'modalShow',
    modalName: 'tesla',
    show: true,
    active: true,
    showNext: false,
    required: true,
  },
];

const Tesla = new Device('teslaExternalEnroll', { mfg: 'tesla', questions, addDevice: null });

export default Tesla;
